<template>
  <v-col v-if="infos">
    <v-row class="pr-1">
      <v-col align="right" class="pa-0" v-for="workerInfo of infos"
             :key="workerInfo.id">
        <v-tooltip max-width="660" bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              small
              :color="getCorrespondingHealth(workerInfo).data.status == 'LOADING' ? 'blue-grey lighten-3': (getCorrespondingHealth(workerInfo).data.status == 'UP' ? 'green lighten-3':'red lighten-3')"
              v-bind="attrs"
              v-on="on">
              mdi-information
            </v-icon>
          </template>


          <v-row v-if="workerInfo.status != 200">
            <v-col>
              {{ workerInfo.statusText }}
            </v-col>
          </v-row>
          <template v-if="workerInfo.status == 200 ">
            <v-row v-if="workerInfo.entity">
              <v-col class="pa-1">
                <strong>Entity</strong>
              </v-col>
              <v-col class="pa-1">
                <strong>{{ workerInfo.entity }}</strong>
              </v-col>
            </v-row>
            <v-row v-for="infoKey of Object.keys(workerInfo.data.app)" :key="infoKey">
              <v-col class="pa-1" v-if="workerInfo.data.app[infoKey]">
                <strong>{{ infoKey }}</strong>
              </v-col>
              <v-col v-if="workerInfo.data.app[infoKey]"
                     :class="infoKey=='commitid'?'text-truncate pa-1 d-inline-block':'pa-1 d-inline-block'">
                {{ workerInfo.data.app[infoKey] }}
              </v-col>
            </v-row>
          </template>
        </v-tooltip>
      </v-col>
    </v-row>
  </v-col>
</template>
<script>

export default {
  components: {},
  name: 'HealthStatusArea',
  props: {
    infos: {
      type: Array,
      required: false
    },
    health: {
      type: Array,
      required: false
    },
    artifact: {
      type: String,
      required: false
    }
  },
  methods: {
    getCorrespondingHealth(workerInfo) {
      if (this.health.length > 1 && workerInfo?.entity) {
        for (const healthStatus of this.health) {
          if (healthStatus.entity == workerInfo.entity) {
            return healthStatus
          }
        }
      } else if (this.health.length == 1) {
        return this.health[0]
      }
      return {data: {status: "LOADING"}}
    }
  },
  data() {
    return {}
  }
}
</script>
